export interface IPropertyMlsStatusProps {
    mls_status_text: string;
}
export function PropertyMlsStatus(props: IPropertyMlsStatusProps) {
    const property_status_text = props.mls_status_text
    if (property_status_text && property_status_text === 'Active') {
        return <div className="label label--forsale  no-wrap font-weight-normal">
            {`Active`}
        </div>
    }
    if (property_status_text && property_status_text === 'Sold') {
        return (<div className="label label--sold no-wrap font-weight-normal">
            {`Sold`}
        </div>)
    }

    if (property_status_text && property_status_text === 'Home Value') {
        return (<div className="label label--notforsale no-wrap font-weight-normal">
            {`Not For Sale`}
        </div>)
    }


    if (property_status_text === 'Under Contract - P' || property_status_text === 'Under Contract - OP' || property_status_text === 'Under Contract - PS' || property_status_text === 'Under Contract - Pending' || property_status_text === 'Pending' || property_status_text === 'Option Pending' || property_status_text === 'Continue to Show') {
        return (<div className="label label--undercontract no-wrap font-weight-normal">
            {property_status_text}
        </div>)
    }

    if (property_status_text === 'Withdrawn' || property_status_text === 'Withdraw') {
        return (<div className="label label--withdraw no-wrap font-weight-normal">
            {`Withdrawn`}
        </div>)
    }


    if (property_status_text === 'Expired') {
        return (<div className="label label--expired no-wrap font-weight-normal">
            {`Expired`}
        </div>)
    }


    if (property_status_text === 'Terminated') {
        return (<div className="label label--terminated no-wrap font-weight-normal">
            {`Terminated`}
        </div>)
    }


    if (property_status_text === 'Coming Soon') {
        return (<div className="label label--comingsoon no-wrap font-weight-normal">
            {`Coming Soon`}
        </div>)
    }


    return <></>;
}